import IDataNotFound from "../../../../shared/interfaces/data-not-found.interface";

export const DATA_NOT_FOUND: IDataNotFound = {
    title: "No hay datos para mostrar",
    description: "¡Busca clases en otros meses!"
};